import { Segmentations } from '@/shared/types/home.types';

interface AdsEventsProps {
  segmentacoes: Segmentations[];
}

type AdsEventsJson = Record<string, string[]>;

export function buildAdsEventsJson(segmentacoes?: Segmentations[] | null): AdsEventsJson {
  const result: AdsEventsJson = {};
  if (!segmentacoes || segmentacoes.length === 0) return result;

  segmentacoes.forEach(seg => {
    if (!seg?.chave) return;

    const values: string[] = [];
    const raw = seg.valor as unknown;

    if (typeof raw === 'string') {
      values.push(raw);
    } else if (Array.isArray(raw)) {
      raw.forEach(item => {
        if (typeof item === 'string') {
          values.push(item);
          return;
        }
        if (Array.isArray(item)) {
          item.forEach(sub => {
            if (typeof sub === 'string') values.push(sub);
          });
        }
      });
    }

    if (values.length > 0) result[seg.chave] = values;
  });

  return result;
}

export default function AdsEvents({ segmentacoes }: AdsEventsProps) {
  const json = buildAdsEventsJson(segmentacoes);
  return (
    <script id="ads-events-json" type="application/json">
      {JSON.stringify(json)}
    </script>
  );
}
